<template>
    <div>
        <div v-show="!initialLoading">
            <div v-show="!orgHasZeroProfiles || openEventsOnly">
                <page-header title="Profiles" menu>
                    <template #menu-content>
                        <div style="min-width: 200px">
                            <div class="pa-2"
                                 style="text-transform: uppercase; background-color: white; font-size: .8em; color: #bdbdbd; font-weight: 500"
                            >Profiles Actions</div>
                            <v-list density="compact">
                                <v-list-item
                                    v-for="(item, index) in profilesActions"
                                    :key="index"
                                    class="pl-2 pr-2"
                                    @click="item.onClick"
                                    :prepend-icon="item.icon"
                                    :title="item.label"
                                >
                                </v-list-item>
                            </v-list>
                        </div>
                    </template>
                    <template #right-content>
                        <div>
                            <AppBtn class="mr-2" style="font-weight: 600" @click="newProfileDialog = true" icon="mdi-plus">Add Profile </AppBtn>
                            <AppBtn v-if="organizationPreferences && organizationPreferences.isSwayVisaEnabled" class="mr-2" style="font-weight: 600" @click="importProfileDialog = true" icon="mdi-upload">Import Profile </AppBtn>
                            <AppBtn class="mr-2" style="font-weight: 600" @click="exportTestsDialogOpen = true" :loading="exportingTestResults" icon="mdi-download">Export Tests </AppBtn>
                            <AppBtn class="mr-2" style="font-weight: 600" @click="exportEventsDialogOpen = true" :loading="exportingEvents" icon="mdi-download">Export Events </AppBtn>
                        </div>
                    </template>
                </page-header>
                <router-view v-slot="{ Component }">
                    <component
                        :is="Component"
                        @finishedInitialLoading="initialLoading = false"
                        @setIsEmpty="setIsEmpty($event)"
                        @setOrgHasZeroProfiles="orgHasZeroProfiles = true"
                    />
                </router-view>
            </div>
            <div v-if="orgHasZeroProfiles && !openEventsOnly" >
                <div style="display: flex; flex-direction: column; justify-content: center; align-items: center">
                    <EmptyState
                        title="No profiles"
                        description="No profiles have been created in this organization. Create a code or manually add a new profile to get started!"
                        :svg="emptyProfilesGraphic"
                    />
                    <AppBtn style="margin-top: 30px" @click="() => $router.push('/codes?createCode=1')">Create A Code</AppBtn>
                    <div style="margin-top: 10px; color: var(--v-text-lighten3)">
                        or
                    </div>
                    <AppBtn style="margin-top: 10px" @click="newProfileDialog = true" color="secondary">Add New Profile</AppBtn>
                    <AppBtn v-if="organizationPreferences.isSwayVisaEnabled" style="margin-top: 10px" @click="importProfileDialog = true" color="secondary">Import Profile</AppBtn>
                </div>
                
            </div>
            
            
        </div>
        <div v-if="initialLoading">
            <AppPageLoader text="Loading Profiles..." />
        </div>
        <div>
            
        </div>

        <dialog-form
            v-if="organizationPreferences"
            :open="newProfileDialog"
            @close="newProfileDialog = false"
            title="Add A New Profile"
            @submit="submitAddProfileForm"
            :width="600"
            :saving="savingProfile"
        >

            <template v-slot:form-content >
                <ProfileCreateUpdateForm
                    :form="newProfileForm"
                    :organizationPreferences="organizationPreferences"
                    :include-groups="true"
                    :groups="groups"
                    :protocols="protocols"
                    creating-profile
                />

            </template>
        </dialog-form>

        <dialog-form
            :open="importProfileDialog"
            @close="importProfileDialog = false"
            title="Add A New Profile"
            @submit="submitImportProfileForm"
            :width="600"
            :saving="savingProfile"
        >

            <template v-slot:form-content >
                <ImportProfileForm
                    :form="importProfileForm"
                    :organizationPreferences="organizationPreferences"
                    :include-groups="true"
                    :groups="groups"
                />

            </template>
        </dialog-form>

        <dialog-form
            :open="exportTestsDialogOpen"
            @close="exportTestsDialogOpen = false"
            title="Export Tests"
            :width="500"
            @submit="getTestResultsExport"
        >
            <template v-slot:form-content>
                <div class="inline-block-field">
                    <app-form-date-picker v-model="exportTestsForm.startDate" label="Start Date" readonly></app-form-date-picker>
                </div>
                <div class="inline-block-field">
                    <app-form-date-picker v-model="exportTestsForm.endDate" label="End Date" readonly></app-form-date-picker>
                </div>
                <div class="inline-block-field">
                    <app-form-checkbox v-model="exportTestsForm.includeSurveys" label="Include On-Field Assessment, VOMS, and other Surveys" readonly></app-form-checkbox>
                </div>
            </template>

        </dialog-form>

        <dialog-form
            :open="exportEventsDialogOpen"
            @close="exportEventsDialogOpen = false"
            title="Export Events"
            :width="500"
            @submit="getEventsExport"
        >
            <template v-slot:form-content>
                <div class="inline-block-field">
                    <app-form-date-picker v-model="exportEventsForm.startDate" label="Start Date" readonly></app-form-date-picker>
                </div>
                <div class="inline-block-field">
                    <app-form-date-picker v-model="exportEventsForm.endDate" label="End Date" readonly></app-form-date-picker>
                </div>
            </template>

        </dialog-form>

        <dialog-form
            :open="exportCovidTestsDialogOpen"
            @close="exportCovidTestsDialogOpen = false"
            title="Export Covid Tests"
            :width="500"
            @submit="getCovidResultsExport"
        >
            <template v-slot:form-content>
                <div class="inline-block-field">
                    <app-form-date-picker v-model="exportCovidTestsForm.startDate" label="Start Date" readonly></app-form-date-picker>
                </div>
                <div class="inline-block-field">
                    <app-form-date-picker v-model="exportCovidTestsForm.endDate" label="End Date" readonly></app-form-date-picker>
                </div>
            </template>

        </dialog-form>
        
<!--        <profiles-table/>-->

    </div>
</template>

<script>
import router from "@/router";
import ProfilesTable from "@/components/ProfilesTable";
import { Field, Form, defineRule, configure } from 'vee-validate'
import {getGroups} from '@/services/groups.service'
import {getProtocols} from '@/services/protocol.service'
import {getTestResultsExport, getEventsExport} from '@/services/organization.service'
import {profileModel, createProfile, importProfile} from '@/services/profile.service'
import moment from 'moment'
import {SET_SNACKBAR} from "@/store/mutation-types";
import {getOrganizationPreferences} from "@/services/organization.service";
import ProfileCreateUpdateForm from "@/components/Profile/ProfileCreateUpdateForm";
import EmptyState from "@/components/EmptyState";
import SwayProfile from "@/js/shared/classes/Profile/SwayProfile";
import emptyProfilesGraphic from '@/assets/svgs/empty-state/empty-group-profile.svg'
import ImportProfileForm from "@/components/Profile/ImportProfileForm.vue";

export default {
    name: "Profiles",
    components: {
        ImportProfileForm,
        EmptyState,
        ProfileCreateUpdateForm,
        ProfilesTable,
        Field,
        Form
    },
    data () {
        return {
            emptyProfilesGraphic,
            orgHasZeroProfiles: false,
            initialLoading: false,
            isEmpty: false,
            exportingTestResults: false,
            exportingEvents: false,
            exportingCovidResults: false,
            exportTestsDialogOpen: false,
            exportEventsDialogOpen: false,
            exportCovidTestsDialogOpen: false,

            exportTestsForm: {
                startDate: null,
                endDate: null,
                includeSurveys: false
            },
            exportEventsForm: {
                startDate: null,
                endDate: null,
            },

            exportCovidTestsForm: {
                startDate: null,
                endDate: null,
            },
            
            valid: false,
            savingProfile: false,
            nameRules: [
                v => !!v || 'Name is required',
                v => v.length <= 10 || 'Name must be less than 10 characters',
            ],
            newProfileDialog: false,
            importProfileDialog: false,
            newProfileForm: null,
            importProfileForm: {
                profileId: null,
                groupIds: [],
                firstName: '',
                lastName: '',
                birthDate: null,
            },
            genderOptions: [
                {
                    label: 'Male',
                    value: 'M'
                },
                {
                    label: 'Female',
                    value: 'F'
                },  
                {
                    label: 'Non-binary',
                    value: 'non-binary'
                },  
            ],
            biologicalSexOptions: [
                {
                    label: 'Male',
                    value: 'male'
                },
                {
                    label: 'Female',
                    value: 'female'
                },
            ],
            name: '',
            phoneNumber: '',
            email: '',
            select: null,
            items: [
                'Item 1',
                'Item 2',
                'Item 3',
                'Item 4',
            ],
            checkbox: null,
            groups: [],
            protocols: [],
            organizationPreferences: null,

	          openEventsOnly: false,
            pendingImportDialog: false,
            pendingImportParams: null,
        }
    },
    beforeMount() {
	    this.openEventsOnly = this.$route?.query?.openEventsOnly === "true" ? true : false
    },
    mounted() {

        this.initialLoading = true;
        this.getOrganizationPreferences()
        this.getGroups()
        this.getProtocols()
        // this.setAddProfileForm()

        this.checkForImportProfileQueryParams()

    },

    watch: {
        // Watch the loading state and required data to trigger the dialog
        groups(newValue) {
            if (newValue.length > 0) {
                this.openPendingImportDialog();
            }
        },
        organizationPreferences(newValue) {
            if (newValue) {
                this.openPendingImportDialog();
            }
        },
        initialLoading(newValue) {
            if (!newValue) {
                this.openPendingImportDialog();
            }
        }
    },

    computed: {
        today() {
            return moment().format('YYYY-MM-DD')
        },
        profilesActions() {
            var actions = [
                {
                    label: 'Add New Profile',
                    onClick: () => { this.newProfileDialog = true },
                    icon: 'mdi-account-plus'
                },
                {
                    label: 'Export Profile Tests',
                    onClick: this.getTestResultsExport,
                    icon: 'mdi-cloud-download'
                },
                {
                    label: 'Export Profile Events',
                    onClick: this.getEventsExport,
                    icon: 'mdi-cloud-download'
                }
            ];
            if (this.organizationPreferences && this.organizationPreferences.enableCovid19Screening) {
                actions.push(
                    {
                        label: 'Export Covid Screenings',
                        onClick: this.getCovidResultsExport,
                        icon: 'mdi-cloud-download'
                    });
            }
        },
    },
    methods: {
        onFinishInitialLoading() {
            this.initialLoading = false;
        },
        setIsEmpty(value) {
            this.isEmpty = value
        },
        async getOrganizationPreferences() {
            const response = await getOrganizationPreferences();
            
            if (!response.isSuccess) return;
            
            const {organizationPreferences} = response;
            this.organizationPreferences = organizationPreferences;
            this.setAddProfileForm()
        },
        // async getAccountProfiles() {
        //     const response = await getAccountProfilesByProfileId();
        //
        //     if (!response.isSuccess) return;
        //
        //     const {accountProfiles} = response;
        //     return accountProfiles;
        // },
        async setAddProfileForm() {
            this.newProfileForm = SwayProfile.getProfileForm({
                isNewProfile: true,
                profile: null,
                isMetric: this.organizationPreferences.isMetric,
                createdInGroupId: null,
            });
            
            this.newProfileForm.accountProfiles = [];

            if (this.$route.query.addProfile === 'true') {
                this.newProfileDialog = true
            }
        },
        async getTestResultsExport() {
            this.exportTestsDialogOpen = false;
            this.exportingTestResults = true;
            const request = {
                startDate: this.exportTestsForm.startDate,
                endDate: this.exportTestsForm.endDate,
                includeSurveys: this.exportTestsForm.includeSurveys,
                groupIds: [],
                profileIds: [],
                isCovidOnly: false,
                orgId: this.$store.getters.selectedOrganizationId
            }
            let response = await getTestResultsExport(request)
            this.exportingTestResults = false;
        },
        async getEventsExport() {
            this.exportEventsDialogOpen = false;
            this.exportingEvents = true;
            const request = {
                startDate: this.exportEventsForm.startDate,
                endDate: this.exportEventsForm.endDate,
                groupIds: [],
                profileIds: [],
                isCovidOnly: false,
                orgId: this.$store.getters.selectedOrganizationId
            }
            let response = await getEventsExport(request)
            this.exportingEvents = false;
        },
        async getCovidResultsExport() {
            this.exportCovidTestsDialogOpen = false;
            this.exportingCovidResults = true;
            const request = {
                startDate: this.exportCovidTestsForm.startDate,
                endDate: this.exportCovidTestsForm.endDate,
                groupIds: [],
                profileIds: [],
                isCovidOnly: true,
                orgId: this.$store.getters.selectedOrganizationId
            }
            let response = await getTestResultsExport(request)
            this.exportingCovidResults = false;
        },
        async getGroups() {
            const response = await getGroups()
            this.groups = response.groups;
        },
        async getProtocols() {
            const response = await getProtocols();
            this.protocols = response.protocols
        },
        async submitAddProfileForm() {
            // console.log(this.newProfileForm);
            this.savingProfile = true;
            
            let request = SwayProfile.getCreateUpdateProfileRequestFromForm({
                form: this.newProfileForm, 
                isMetric: this.organizationPreferences.isMetric, 
                isMobile: false,
                enableSportsProfileProperties: this.organizationPreferences.enableSportsProfileProperties
            });
            
            // console.log(request)
            // 
            
            let response = await createProfile({profile: request});

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
                this.savingProfile = false;
                return
            }
            const createdProfile = response.profile;
            this.newProfileDialog = false;
            this.savingProfile = false;
            this.$store.commit(SET_SNACKBAR, {
                text: 'Profile Successfully Created',
                color: 'success',
                open: true
            });
            await this.$router.push(`/profiles/${createdProfile.id}/overview`)
            
        },
        checkForImportProfileQueryParams() {
            const { importProfile, firstName, lastName, profileId } = this.$route.query;

            // Store query parameters for later use
            if (importProfile === 'true') {
                this.pendingImportDialog = true;
                this.pendingImportParams = {
                    profileId: profileId ? parseInt(profileId) : null,
                    firstName: firstName || '',
                    lastName: lastName || ''
                };

                // Clear the query parameters but preserve others
                const query = {...this.$route.query};
                delete query.importProfile;
                delete query.firstName;
                delete query.lastName;
                delete query.profileId;

                if (Object.keys(query).length > 0) {
                    this.$router.replace({query});
                } else {
                    this.$router.replace({path: this.$route.path});
                }
            }
        },

        // Open the import dialog when all required data is loaded
        openPendingImportDialog() {
            if (this.pendingImportDialog &&
                this.organizationPreferences?.isSwayVisaEnabled &&
                this.groups.length > 0 &&
                !this.initialLoading) {

                // Ensure we have the form ready
                if (this.pendingImportParams) {
                    if (this.pendingImportParams.profileId) {
                        this.importProfileForm.profileId = this.pendingImportParams.profileId;
                    }
                    if (this.pendingImportParams.firstName) {
                        this.importProfileForm.firstName = this.pendingImportParams.firstName;
                    }
                    if (this.pendingImportParams.lastName) {
                        this.importProfileForm.lastName = this.pendingImportParams.lastName;
                    }
                }

                // We need to use $nextTick to ensure Vue has finished updating the DOM
                this.$nextTick(() => {
                    // Add a slight delay to ensure everything is ready
                    setTimeout(() => {
                        this.importProfileDialog = true;
                        this.pendingImportDialog = false; // Reset pending state
                    }, 250);
                });
            }
        },

        async submitImportProfileForm() {
            // console.log(this.newProfileForm);
            this.savingProfile = true;

            //model needs to match the model in the API
            //public class ImportProfileRequest
            // {
            //     public int ProfileId { get; set; }
            //     public int OrganizationId { get; set; }
            //     public List<int> GroupIds { get; set; }
            //     public string FirstName { get; set; }
            //     public string LastName { get; set; }
            //     public DateTime BirthDate { get; set; }
            // }

            let request = {
                profileId: this.importProfileForm.profileId,
                //organizationId: this.newProfileForm.organizationId,
                groupIds: this.importProfileForm.groupIds,
                firstName: this.importProfileForm.firstName,
                lastName: this.importProfileForm.lastName,
                birthDate: this.importProfileForm.birthDate,
            };

            // console.log(request)
            //

            let response = await importProfile(request);

            if (!response.isSuccess) {
                this.$store.commit(SET_SNACKBAR, {
                    text: response.errors[0].message,
                    color: 'error',
                    open: true
                });
                this.savingProfile = false;
                return
            }
            const createdProfile = response.profile;
            this.importProfileDialog = false;
            this.savingProfile = false;
            this.$store.commit(SET_SNACKBAR, {
                text: 'Profile Successfully Imported',
                color: 'success',
                open: true
            });
            await this.$router.push(`/profiles/${createdProfile.id}/overview`)

        }
    },
}
</script>

<style scoped>
.row-pointer :deep(tbody tr:hover) {
    cursor: pointer;
}
</style>